<kendo-drawer-container class="k-h-full">
    <kendo-drawer
        #drawer
        class="!k-flex-none k-overflow-y-auto !k-pos-fixed k-h-screen"
        [items]="items"
        [mini]="true"
        [(expanded)]="expanded"
        mode="overlay"
        (select)="onItemSelection($event)"
    >
        <ng-template kendoDrawerHeaderTemplate>
            <div class="k-drawer-item k-level-0" (click)="drawer.toggle()">
                <kendo-svg-icon [icon]="menuIcon"></kendo-svg-icon>
                @if(expanded){
                <span>Menu</span>
                }
            </div>
        </ng-template>
        <ng-template kendoDrawerItemTemplate let-item>
            <div class="k-drawer-link" [routerLink]="'./' + item.path">
                <kendo-svgicon [icon]="item.svgIcon"></kendo-svgicon>
                @if(expanded){
                <span>{{ item.text }}</span>
                }
            </div>
        </ng-template>
    </kendo-drawer>

    <kendo-drawer-content [style.paddingLeft.px]="50" class="app-shell">
        <app-header class="app-shell-header"></app-header>
        <main class="app-shell-main">
            <router-outlet *ngIf="userDataReady"></router-outlet>
        </main>
        <app-footer class="app-shell-footer"></app-footer>
    </kendo-drawer-content>
</kendo-drawer-container>

<!-- Deployment bulletin overlay - visible to all users -->
<app-deployment-bulletin></app-deployment-bulletin>
